// extracted by mini-css-extract-plugin
module.exports = {"logo":"_02712f2b3b--logo--e0PEF","link":"_02712f2b3b--link--liFPD"};